<div class="dialog">
    <h2 class="dialog__title">Remove {{ data.cityName }}</h2>

    <p class="dialog__description">
        Are you sure you want to remove <b>{{ data.cityName }}</b> from your trip itinerary?
        <span [class.not-actual]="maintainDuration">By removing <b>{{ data.cityName }}</b>, your trip duration will be shortened by {{ data.minusDays }}
            days</span>
    </p>

    @if (data.isOptimizedMode) {
        <div class="dialog__checkbox">
            <mat-checkbox [(ngModel)]="maintainDuration">
                <span>Maintain current duration. change itinerary accordingly</span>
            </mat-checkbox>
        </div>
    }

    @if (data.newEndDate && !maintainDuration) {
        <p class="dialog__notice-info">
            New return date: {{ data.newEndDate }}
        </p>
    }

    <div class="dialog__actions">
        <button
            class="dialog__button dialog__button--cancel"
            (click)="closeModal({res: false, maintain: false})"
        >
            Cancel
        </button>
        <button
            class="dialog__button dialog__button--confirm"
            (click)="closeModal({res: true, maintain: maintainDuration})"
        >
            Yes, please remove
        </button>
    </div>
</div>
